import BLACK_TILE from "Assets/images/map/blacktile.jpg";

class CoordMapType {
  tileSize: google.maps.Size;

  baseTilePath = "";

  minZoom = 9;

  maxZoom = 24;

  name = "Tile #s";

  alt = "Tile Coordinate Map Type";

  version = "1";

  tileCache = {};

  mapTiles = [];

  constructor(
    mapTiles: any,
    baseTilePath: string,
    minZoom: number,
    maxZoom: number,
    cacheVersion?: string,
    tileName?: string,
    altText?: string,
    tileSize?: google.maps.Size
  ) {
    this.mapTiles = mapTiles;
    this.baseTilePath = baseTilePath;
    this.minZoom = minZoom || 9;
    this.maxZoom = maxZoom || 11;
    this.version = cacheVersion;
    this.name = tileName || "Tile #s";
    this.alt = altText || "Tile Coordinate Map Type";
    this.tileSize = tileSize || new window.google.maps.Size(256, 256);
  }

  CustomGetTileUrl(coord: google.maps.Point, zoom: number) {
    return this.mapTiles.reduce((tileUrl, prop) => {
      if (
        zoom === prop.zoom &&
        coord.x >= prop.minx &&
        coord.x <= prop.maxx &&
        coord.y >= prop.miny &&
        coord.y <= prop.maxy
      ) {
        return `${this.baseTilePath}${coord.x}_${coord.y}_${zoom}.jpg?v=${this.version}`;
      }
      return tileUrl || BLACK_TILE;
    }, "");
  }

  getTile(
    coord: google.maps.Point,
    zoom: number,
    ownerDocument: Document
  ): HTMLElement {
    // We should add a loc_id and tourid to the cache
    // to swap easily between locations/tours
    // since we dont current account for that
    const id = `id${coord.x}${coord.y}${zoom}`;

    if (id in this.tileCache) {
      return this.tileCache[id];
    }

    const img = ownerDocument.createElement("img");

    img.src = this.CustomGetTileUrl(coord, zoom);
    img.style.width = `${this.tileSize.width}px`;
    img.style.height = `${this.tileSize.height}px`;
    img.alt = "Map tile for experience map.";
    img.id = id;

    this.tileCache[id] = img;

    return img;
  }

  clearCache() {
    this.tileCache = {};
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  releaseTile = (_tile: HTMLElement) => {};
}

export default CoordMapType;
